import { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import MenuComponent from "../components/Menu.tsx";

function Support() {
  const { authorization, SetAuthorization } = useAuth();

  const NewSupport = () => {
    const support = {
      FirstName: "",
      LastName: "",
      Email: "",
      Telephone: "",
      Message: "",
      Type: ""
    }
    return support;
  }

  const [support, SetSupport] = useState(NewSupport());
  const [display_success, SetSuccess] = useState(false);

  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(support)
    };

    console.log(support);

    fetch("/api/support", options)
      .then(response => response.text())
      .then(data => {
        SetSupport(NewSupport());
        SetSuccess(true);
      })
      .catch(error => console.log(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetSupport((prevState) => ({ ...prevState, [name]: value }));
  }

  return (
    <>
      <Snackbar open={display_success} onClose={() => SetSuccess(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="success" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Your support request has been sent.  Someone from our team will contact you shortly.
        </Alert>
      </Snackbar>

      <MenuComponent page={"Support"} />

      <section id="main">
        <div className="container">
          <p>Please complete the form below if you require support or assistance. A member of our technical support team will respond to technical support related requests within one business day. <strong>All fields are required.</strong></p>
          <form onSubmit={Submit}>
            <p className="half">
              <label>First Name
                <input type="text" name="FirstName" value={support.FirstName} onChange={OnChange} required />
              </label>
              <label>Last Name
                <input type="text" name="LastName" value={support.LastName} onChange={OnChange} required />
              </label>
            </p>
            <p>
              <label>Email Address
                <input type="text" name="Email" value={support.Email} onChange={OnChange} required />
              </label>
            </p>
            <p className="half">
              <label>Phone Number
                <input type="text" name="Telephone" value={support.Telephone} onChange={OnChange} required />
              </label>
            </p>
            <p>
              <label>Message
                <textarea name="Message" value={support.Message} onChange={OnChange} required></textarea>
              </label>
            </p>
            {!authorization.IsAdministrator &&
              <p>
                <label>Type of Support Required?
                  <span className="double">
                    <label className="form-control"><input type="radio" id="program" name="Type" value="inquiry" onChange={OnChange} /> RCIP Program Inquiry </label>
                    <label className="form-control"><input type="radio" id="technical" name="Type" value="technical" onChange={OnChange} /> Technical Support </label>
                  </span>
                </label>
              </p>
            }
            <p className="formButton"><input type="submit" value="Submit" /></p>
          </form>
        </div>
      </section>
    </>
  );
}

export default Support;